/*global google*/
import Cookies from "js-cookie";
import Util from "../util/Util";

import ScrollMagic from "scrollmagic";
import {gsap, Power0} from "gsap";

import {ScrollToPlugin} from "gsap/ScrollToPlugin";
import {MorphSVGPlugin} from "gsap/MorphSVGPlugin";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(MorphSVGPlugin);

export default {
    init() {
        /* JS APERTURA SUBMENU MOBILE */
        if ($(window).width() < 992) {
            $(".sub-menu").hide();
            $(".sub-menu").removeClass("open-sub-menu");
            $(".nst-nav > li > a").on("click", function (e) {
                e.preventDefault();
                if ($(this).next().hasClass("open-sub-menu")) {
                    $(this).next().removeClass("open-sub-menu");
                    $(".nst-nav .sub-menu").slideUp();
                } else {
                    $(".nst-nav .sub-menu").slideUp();
                    $(".sub-menu").removeClass("open-sub-menu");
                    $(this).next().addClass("open-sub-menu");
                    $(this).next().slideDown();
                }
            });
        }

        /* JS GOOGLE MAPS */
        let mapsContainer = $(".maps-container");

        function mapsinit()
        {
            let googleLat = mapsContainer.data("lat");
            let googleLong = mapsContainer.data("long");
            let googleIconPin = mapsContainer.data("icon-pin");
            let googleLink = mapsContainer.data("link");
            var centerLatLng = new google.maps.LatLng(googleLat, googleLong);

            var mapOptions = {
                zoom: 15,
                center: centerLatLng,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                styles: [
                    {
                        "featureType": "all",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "weight": "2.00",
                        },
                        ],
                },
                    {
                        "featureType": "all",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#9C9C9C",
                        },
                        ],
                },
                    {
                        "featureType": "all",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "on",
                        },
                        ],
                },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#F2F2F2",
                        },
                        ],
                },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#FFFFFF",
                        },
                        ],
                },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#FFFFFF",
                        },
                        ],
                },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off",
                        },
                        ],
                },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "saturation": -100,
                        },
                            {
                                "lightness": 45,
                        },
                        ],
                },
                    {
                        "featureType": "road",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#eeeeee",
                        },
                        ],
                },
                    {
                        "featureType": "road",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#7b7b7b",
                        },
                        ],
                },
                    {
                        "featureType": "road",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#FFFFFF",
                        },
                        ],
                },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "simplified",
                        },
                        ],
                },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off",
                        },
                        ],
                },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off",
                        },
                        ],
                },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#46BCEC",
                        },
                            {
                                "visibility": "on",
                        },
                        ],
                },
                    {
                        "featureType": "water",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#C8D7D4",
                        },
                        ],
                },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#070707",
                        },
                        ],
                },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#FFFFFF",
                        },
                        ],
                },
                ],
            };
            //var iconBase = window.location.protocol + "//" + window.location.host + "/" + "app/themes/pigreco/dist/images/";
            var icon = {
                url: googleIconPin,
                scaledSize: new google.maps.Size(100, 100),
            };
            var mapElement = document.getElementById("map");
            var map = new google.maps.Map(mapElement, mapOptions);

            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(googleLat, googleLong),
                draggable: false,
                animation: google.maps.Animation.DROP,
                map: map,
                icon: icon,
                scaledSize: new google.maps.Size(100, 100),
                title: "Non Solo Tata",
                url: googleLink,
            });

            google.maps.event.addListener(marker, "click", function () {
                if (marker.url.length > 0) {
                    window.open(marker.url);
                }
            });
        }

        if (mapsContainer.length > 0) {
            google.maps.event.addDomListener(window, "load", mapsinit);
        }

        /* JS AGGIUNTA CUSTOM CHECKBOX PRIVACY FORMS */
        $(".form-box .input-privacy .wpcf7-list-item label").append("<span class=\"nst-checkmark\"></span>");
        $(".nst-form-footer .input-privacy .wpcf7-list-item label").append("<span class=\"nst-checkmark\"></span>");

        /* JS AGGIUNTA POPUP TESTO COOKIE POLICY */
        $(".input-privacy").append("<span class=\"tooltiptext\">Acconsento al trattamento dei dati personali in qualità di interessato, avendo letto l’informativa privacy policy redatta ai sensi dell’articolo 23 del D.Lgs. n. 196/2003 e s.m.i..\n" +
            "<br><br>" +
            "Acconsento espressamente al trattamento dei dati personali per finalità di marketing ed invio di materiale pubblicitario relativo ad iniziative, prodotti e servizi della Società, sia con mezzi automatizzati senza intervento dell’operatore (es. newsletter, sms, mms, posta elettronica, ecc) che tradizionali (tramite telefono, posta) e/o tramite aree riservate e private del Sito Internet.\n" +
            "<br><br>" +
            "Acconsento espressamente al trattamento dei Suoi dati personali per finalità di profilazione a scopi di pubblicità comportamentale.\n" +
            "<br><br>" +
            "Acconsento espressamente al trattamento dei Suoi dati personali per finalità di indagini di mercato e sulla soddisfazione della clientela, mediante interviste personali o telefoniche, o altri mezzi di rilevazione (questionari, ecc).</span>");

        /* SELECT2 PER FORM 100% TPL */
        $(".form-100-tpl-nst .input-select select").select2({
            minimumResultsForSearch: Infinity,
            dropdownCssClass: "form-100-tpl-nst-dropdown",
        });

        /* SELECT2 PER FORM 50% TPL */
        $(".form-50-tpl-nst .input-select select").select2({
            minimumResultsForSearch: Infinity,
            dropdownCssClass: "form-50-tpl-nst-dropdown",
        });

        /* SELECT2 PER FORM POST TPL (ARTICOLI CORSI/EVENTI) */
        $(".form-post-nst .input-select select").select2({
            minimumResultsForSearch: Infinity,
            dropdownCssClass: "form-post-nst-dropdown",
        });

        /* SELECT2 PER FORM NEL FOOTER */
        $(".nst-form-footer .input-select select").select2({
            minimumResultsForSearch: Infinity,
            dropdownCssClass: "footer-custom-dropdown",
        });

        /* JS PER NASCONDERE FRECCETTA SELECT2 DEFAULT E AGGIUNTA FRECCETTA CUSTOM FONTAWESOME */
        $(".input-select b[role=\"presentation\"]").hide();
        $(".input-select .select2-selection__arrow").append("<i class=\"far fa-angle-down\"></i>");

        /* JS GESTIONE MOSTRA/NASCONDI BOTTONE RIABILITAZIONE ALGORITMO SU POPUP CAMBIO UTENTE */
    if ($(".renable-alg").length > 0) {
        var cookieUser = JSON.parse(Cookies.get("user"));
        var disableButton = $(".renable-alg").parent();
        if (cookieUser["disable"]) {
            disableButton.show();
        } else {
            disableButton.hide();
        }
    }
        /* JS GESTIONE COOKIE USER */
        $(".typed").each(function () {
            let clicked = false;
            $(this).on("click", function () {
                if (!clicked) {
                    clicked = true;
                    var usertype = null;
                    var cookieUser = Util.getUserCookie();

                    // TODO: Valutare se aggiungere un "flag" che permetta di decidere se abilitare o meno il filtro per servizi
                    //Funzione per gestione voci menu
                    if ($(this).hasClass("menu-item")) {
                        var isotope_filter = $(this).find("a").data("isotope-filter");
                        if (isotope_filter) {
                            Cookies.set("isotope_filter", {usertype: isotope_filter}, {expires: 30});
                        } else {
                            Cookies.set("isotope_filter", {usertype: ""}, {expires: 30});
                        }

                        var clickedUsertype = $(this).find("a").data("usertype");
                        if (clickedUsertype) {
                            Util.setCookiePoint(clickedUsertype)
                        }
                    }

                    //Funzione per disabilitare l'algoritmo e settare uno specifico usertype
                    if ($(this).hasClass("force-alg")) {
                        usertype = $(this).data("usertype");
                        if (usertype !== undefined) {
                            cookieUser["usertype"] = usertype;
                            cookieUser["disable"] = true;
                            Util.setUserCookie(cookieUser);
                            location.reload();
                        }
                    }

                    //Funzione per riabilitare l'algoritmo
                    if ($(this).hasClass("renable-alg")) {
                        cookieUser["disable"] = false;
                        cookieUser["usertype"] = -1;
                        Util.setUserCookie(cookieUser);
                        location.reload();
                    }

                    if ($(this).hasClass("change-usertype")) {
                        if ($(this).data("usertype")) {
                            usertype = $(this).data("usertype");
                        } else {
                            usertype = $("[data-filter-group='usertype']").find(".active").data("value");
                            if (!usertype) {
                                usertype = $($("[data-filter-group='usertype']")[0]).select2("data")[0]["id"];
                            }
                        }

                        if (usertype.includes("u")) {
                            usertype = Object.keys(cookieUser["types"]).find(key => cookieUser["types"][key] === usertype);
                        }

                        if (usertype === "") {
                            usertype = -1;
                        }

                        cookieUser["navigation"]["new"] = usertype;
                        cookieUser["navigation"]["isChanged"] = true;
                        Util.setUserCookie(cookieUser);

                        if (usertype !== -1) {
                            Util.setCookiePoint(usertype);
                        }
                    }
                }
            });
        });

    },
    finalize() {

    },
    onLoad() {

        /* JS GESTIONE APERTURA/CHIUSURA MENU PRINCIPALE SITO CON GESTIONE ANCHOR */
        var openMenu = $(".open-menu");
        var menuContainer = $(".menu-container");
        var breadcrumbs = $(".breadcrumbs-container");
        let url = window.location.href;

        if (url.substring(url.lastIndexOf("/") + 1).charAt(0) === "#" &&
            url.substring(url.lastIndexOf("/") + 1).length > 1) {
            gsap.to(window, {duration: 1, scrollTo: url.substring(url.lastIndexOf("/") + 1)})
        }

        openMenu.on("click", function () {
            openMenu.toggleClass("is-active");
            var menu = gsap.timeline();
            if (openMenu.hasClass("is-active")) {
                menuContainer.addClass("is-open");
                breadcrumbs.addClass("b-hide");
                menu.to(menuContainer, .3, {
                    right: 0,
                    ease: Power0.easeIn,
                });
                menu.staggerFromTo(".is-open .nst-nav .pi-first-level-menu", .2, {
                    transform: "translate3d(-40px,0,0)",
                    autoAlpha: 0,
                }, {
                    transform: "translate3d(0,0,0)",
                    autoAlpha: 1,
                }, .1);
            } else {
                menuContainer.addClass("is-open");
                breadcrumbs.removeClass("b-hide");
                menu.to(menuContainer, .3, {
                    right: "-100%",
                    ease: Power0.easeIn,
                });
            }

            if (openMenu.hasClass("white")) {
                $(this).removeClass("white");
            }
        });

        /* JS GESTIONE ANIMAZIONE APERTURA/CHIUSURA MENU DALL'ALTO CAMBIO UTENTE */
        /* SOSTITUITO DA POPUP */
        /*
        let userMessage = $(".user-message");
        let userMessageMobile = $(".user-message-mobile");
        let openBoxMessage = $(".open-box-message");
        let openBoxMessageMobile = $(".open-box-message-mobile");
        let textRow = $(".text-row");
        let textRowMobile = $(".text-row-mobile");

        let heightTop = userMessage.innerHeight() - textRow.innerHeight();
        let heightBottom = userMessageMobile.innerHeight() - textRowMobile.innerHeight();

        var arrow = gsap.timeline();

        arrow.to(userMessage, .3, {
            top: "-" + (userMessage.innerHeight()) + "px",
            ease: "none",
        }, "+=10");

        arrow.to(userMessageMobile, .3, {
            bottom: "-" + (userMessageMobile.innerHeight()) + "px",
            ease: "none",
        }, "+=10");

        if ($(window).width() > 992) {
            userMessage.css("top", -heightTop).css("opacity", "1");
            openBoxMessage.on("click", function (e) {
                e.preventDefault();
                openBoxMessage.toggleClass("is-active");
                var box = gsap.timeline();
                if (openBoxMessage.hasClass("is-active")) {
                    userMessage.addClass("is-open");
                    box.to(userMessage, .5, {
                        top: 0,
                        ease: "none",
                        });
                } else {
                    userMessage.removeClass("is-open");
                    box.to(userMessage, .3, {
                        top: "-" + (heightTop) + "px",
                        ease: "none",
                        });
                }
            });
        } else {
            userMessageMobile.css("bottom", -heightBottom).css("opacity", "1");
            openBoxMessageMobile.on("click", function (e) {
                e.preventDefault();
                openBoxMessageMobile.toggleClass("is-active");
                var box = gsap.timeline();
                if (openBoxMessageMobile.hasClass("is-active")) {
                    userMessageMobile.addClass("is-open");
                    box.to(userMessageMobile, .5, {
                        bottom: 0,
                        ease: "none",
                        });
                } else {
                    userMessageMobile.removeClass("is-open");
                    box.to(userMessageMobile, .3, {
                        bottom: "-" + (heightBottom) + "px",
                        ease: "none",
                        });
                }
            });
        }
        */

        /* JS GESTIONE SCROLL CONTENUTO SE TROPPO LUNGO SU TPL SINGOLO POST/SERVIZI */
        /* STESSO CODICE PRESENTE SU ON RESIZE() */
        let mainDescContainer = $(".scroll-headers .desc-breve");
        let innerDescContainer = $(".scroll-headers .inner-desc");
        let scrollDownDesc = $(".scroll-headers .scroll-down");
    if ($(window).width() > 992) {
        if (mainDescContainer.length > 0 && innerDescContainer.length > 0) {
            if (innerDescContainer.outerHeight() > mainDescContainer.outerHeight()) {
                mainDescContainer.addClass("scroll-description");
                scrollDownDesc.addClass("enabled");
                scrollDownDesc.on("click", function (e) {
                    e.preventDefault();
                    mainDescContainer.animate({
                        scrollTop: mainDescContainer.outerHeight(),
                        }, 1500);
                });
            }
        }
    }

        /* JS INIZIALIZZAZIONE OWLCAROUSEL HEADERS */
        let headerSlider = $(".page-header-80-image .header-slider");
    if (headerSlider.length > 0) {
        headerSlider.owlCarousel({
            loop: false,
            nav: true,
            navText: ["<i class=\"far fa-chevron-left\"></i>", "<i class=\"far fa-chevron-right\"></i>"],
            dots: true,
            animateIn: "fadeIn",
            animateOut: "fadeOut",
            center: false,
            items: 1,
            });
    }

        /* JS PER CAMBIO COLORE LOGO E MENU */
        let c1 = new ScrollMagic.Controller();
        let nstLogo = $(".nst-logo");
        let nstMenu = $(".nst-menu");

    if ($(window).width() > 990) {
        if (nstLogo.length > 0) {
            /* Aggiunta class "white" ogni volta che il logo si posiziona sopra ad una foto */
            $(".header-logo-color-trigger").each(function () {
                new ScrollMagic.Scene({
                    triggerElement: $(this).parent(),
                    triggerHook: "0",
                    offset: "-70",
                    duration: $(this).parent().height(),
                    })
                .setClassToggle(".nst-logo .brand", "white")
                //.addIndicators()
                .addTo(c1);
            });

            /* Aggiunta class "hide" quando il logo raggiunge il footer */
            new ScrollMagic.Scene({
                triggerElement: ".header-footer-color-trigger",
                triggerHook: "0",
                offset: "-200",
                duration: $("footer").height(),
                })
            .setClassToggle(".nst-logo", "hide")
            //.addIndicators()
            .addTo(c1);
        }

        if (nstMenu.length > 0) {
            /* Aggiunta class "white" ogni volta che il menu si posiziona sopra ad una foto */
            $(".header-menu-color-trigger").each(function () {
                new ScrollMagic.Scene({
                    triggerElement: $(this).parent(),
                    triggerHook: "0",
                    offset: "-70",
                    duration: $(this).parent().height(),
                    })
                .setClassToggle(".nst-menu .open-menu", "white")
                //.addIndicators()
                .addTo(c1);
            });

            /* Aggiunta class "hide" quando il menu raggiunge il footer */
            new ScrollMagic.Scene({
                triggerElement: ".header-footer-color-trigger",
                triggerHook: "0",
                offset: "-150",
                duration: "200",
                })
            .setClassToggle(".nst-menu .open-menu", "white")
            //.addIndicators()
            .addTo(c1);
        }

        if ($(".open-cambio-utente").length > 0) {
            /* Aggiunta class "change-col" quando il bottone di apertura popup cambio utente raggiunge il footer */
            new ScrollMagic.Scene({
                triggerElement: ".header-footer-color-trigger",
                triggerHook: "1",
                })
            .setClassToggle(".open-cambio-utente", "change-col")
            //.addIndicators()
            .addTo(c1);
        }
    }

    if ($(".stain").length > 0) {
        $(".stain").each(function () {
            var stain = $(this);
            var first = stain.find("path:first-child");

            if (first.length > 0) {
                first.css("fill", stain.data("fill"));
                var tl = gsap.timeline({repeat: -1, yoyo: true});
                var duration = Math.floor(Math.random() * 10) + 20;

                var step_complete = false;
                var prev = first;

                while (!step_complete) {
                    var next = null;
                    if (prev.next().length > 0) {
                        next = prev.next();
                    } else {
                        step_complete = true;
                        continue;
                    }

                    var step = gsap.to(first, {
                        morphSVG: {shape: next, type: "rotational"},
                        duration: duration,
                        ease: "none",
                        });
                    tl.add(step);
                    prev = next;
                }

                tl.play();
            }
        });
    }

    },
    onResize() {
        /* JS GESTIONE SCROLL CONTENUTO SE TROPPO LUNGO SU TPL SINGOLO POST/SERVIZI */
        /* STESSO CODICE PRESENTE SU ON LOAD() */
        let mainDescContainer = $(".scroll-headers .desc-breve");
        let innerDescContainer = $(".scroll-headers .inner-desc");
        let scrollDownDesc = $(".scroll-headers .scroll-down");

        if ($(window).width() > 992) {
            if (mainDescContainer.length > 0 && innerDescContainer.length > 0) {
                if (innerDescContainer.outerHeight() > mainDescContainer.outerHeight()) {
                    mainDescContainer.addClass("scroll-description");
                    scrollDownDesc.addClass("enabled");
                    scrollDownDesc.on("click", function (e) {
                        e.preventDefault();
                        mainDescContainer.animate({
                            scrollTop: mainDescContainer.outerHeight(),
                        }, 1500);
                    });
                }
            }
        }
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js